import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ConfirmPasswordValidator } from "../passwordchange/passwordchange.component";
export interface Profile {
    id: number,
    idparent: number,
    username: string,
    fullname: string,
    email: string,
    city: string,
    address1: string,
    address2: string,
    company: string,
    contact: string,
    type: number,
    first_name: string,
    last_name: string,
    profile_image: string,
    message: string,
    state: string,
    post_code: any,
    calleridname: string,
    timezone: string,
    agentcode: string,
    entity_type:number
}

export interface HTTPProfile {
    fullname: string,
    company: string,
    email: string,
    city: string,
    address1: string,
    address2: string,
    contact: string,
    first_name: string,
    last_name: string,
    state: string,
    post_code: number,
    agentcode: string,
    calleridname: string,
    timezone: string
}

export class ProfileForm implements HTTPProfile {
    public fullname: string;
    public email: string;
    public city: string;
    public address1: string;
    public address2: string;
    public company: string;
    public contact: string;
    public first_name: string;
    public last_name: string;
    public state: string;
    public post_code: number;
    public agentcode: string;
    public calleridname: string;
    public timezone: string;
    constructor(data: Profile) {
        if (data == null) {
            this.fullname = "";
            this.email = "";
            this.city = "";
            this.address1 = "";
            this.address2 = "";
            this.company = "";
            this.contact = "";
            this.first_name = "";
            this.last_name = "";
            this.state = "";
            this.post_code = null;
            this.agentcode = null;
            this.calleridname = ""
            this.timezone = "0";
        }
        else {
            this.fullname = data.fullname;
            this.email = data.email;
            this.city = data.city;
            this.address1 = data.address1;
            this.address2 = data.address2;
            this.company = data.company;
            this.contact = data.contact;
            this.first_name = data.first_name;
            this.last_name = data.last_name;
            this.state = data.state;
            this.post_code = data.post_code;
            this.agentcode = data.agentcode;
            this.calleridname = data.calleridname;
            this.timezone = data.timezone;
        }
    }


    public makeform(fb: FormBuilder): FormGroup {
        return fb.group({
            fullname: [this.fullname],
            email: [this.email],
            city: [this.city],
            address1: [this.address1],
            address2: [this.address2],
            company: [this.company],
            contact: [this.contact],
            first_name: [this.first_name],
            last_name: [this.last_name],
            state: [this.state],
            post_code: [this.post_code],
            agentcode: [this.agentcode],

            calleridname: [this.calleridname],
            timezone: [this.timezone]

        });
    }

    public saveForm(fg: FormGroup): boolean {
        if (fg.valid) {
            this.company = fg.get("company").value;
            this.fullname = fg.get("fullname").value;
            this.email = fg.get("email").value;
            this.city = fg.get("city").value;
            this.address1 = fg.get("address1").value;
            this.address2 = fg.get("address2").value;
            this.contact = fg.get("contact").value;
            this.first_name = fg.get("first_name").value;
            this.last_name = fg.get("last_name").value;
            this.state = fg.get("state").value;
            this.post_code = fg.get("post_code").value;
            this.agentcode = fg.get("agentcode").value;


            this.calleridname = fg.get("calleridname").value;
            this.timezone = fg.get("timezone").value;
            return true;
        }
        else {
            return false;
        }
    }
}

/* Reset Password Model Start */
export interface Password {
    newpassword: string;
    confirmpassword: string;
    oldpassword: string;
    message: string;
}

export interface HTTPPassword {
    newpassword: string;
    confirmpassword: string;
    oldpassword: string;
}

export class PasswordForm implements HTTPPassword {
    public newpassword: string;
    public confirmpassword: string;
    public oldpassword: string;
    constructor(data: Password) {
        if (data == null) {
            this.newpassword = "";
            this.confirmpassword = "";
            this.oldpassword = "";

        } else {
            this.newpassword = (data.newpassword) ? data.newpassword : "";
            this.confirmpassword = (data.confirmpassword) ? data.confirmpassword : "";
            this.oldpassword = (data.oldpassword) ? data.oldpassword : "";

        }
    }
    public makeform(fb: FormBuilder): FormGroup {
        return fb.group(

            {
                oldpassword: ["", Validators.required],
                newpassword: ["", Validators.required],
                confirmpassword: ["", Validators.required]
            },
            {
                validator: ConfirmPasswordValidator("newpassword", "confirmpassword")
            }
        );
        //         {
        //       newpassword       : [this.newpassword,Validators.required],
        //       confirmpassword   : [this.confirmpassword,[Validators.required,Validators.pattern('(?=.[a-z])(?=.[A-Z])(?=.[0-9])(?=.[$@$!%#?^&+=,.-])[A-Za-z\d$@$!%#?^&+=,.-].{8,}')]],
        //       oldpassword       : [this.oldpassword,Validators.required]

        //   },


    }

    public saveForm(fg: FormGroup): boolean {
        if (fg.valid) {
            this.newpassword = fg.get("newpassword").value;
            this.confirmpassword = fg.get("confirmpassword").value;
            this.oldpassword = fg.get("oldpassword").value;
            if (this.newpassword !== this.confirmpassword) {
                return false;
            }
            return true;
        }
        else {
            return false;
        }
    }
}

/* Vertual Mentor Account Model */
export interface VMuser {
    id: number,
    vmusername: string,
    vmpassword: string,
    iduser: number,
    lead: number,
    cdr: number,
    disposition: number,
    voicemail: number,
    sms: number,
    email: number,
    objection: number,
    didcredit: number,
    vm_iduser: number
}

export interface HTTPVMuser {
    vmusername: string,
    vmpassword: string,
    iduser: number,
    lead: number,
    cdr: number,
    disposition: number,
    voicemail: number,
    sms: number,
    email: number,
    objection: number,
    didcredit: number

}

export class VMuserForm implements HTTPVMuser {
    public vmusername: string;
    public vmpassword: string;
    public iduser: number;
    public lead: number;
    public cdr: number;
    public disposition: number;
    public voicemail: number;
    public sms: number;
    public email: number;
    public objection: number;
    public didcredit: number;

    constructor(data: VMuser) {
        if (data == null) {
            this.vmusername = "";
            this.vmpassword = "";
            this.iduser = parseInt(sessionStorage.getItem("userid"));
            this.lead = 1;
            this.cdr = 0;
            this.disposition = 0;
            this.voicemail = 0;
            this.sms = 0;
            this.email = 0;
            this.objection = 0;
            this.didcredit = 0;
        }
        else {
            this.vmusername = data.vmusername;
            this.vmpassword = data.vmpassword;
            this.iduser = parseInt(sessionStorage.getItem("userid"));
            this.lead = data.lead;
            this.cdr = data.cdr;
            this.disposition = data.disposition;
            this.voicemail = data.voicemail;
            this.sms = data.sms;
            this.email = data.email;
            this.objection = data.objection;
            this.didcredit = data.didcredit;
        }
    }
    public makeform(fb: FormBuilder): FormGroup {
        return fb.group({
            vmusername: [this.vmusername],
            vmpassword: [this.vmpassword],
            iduser: [parseInt(sessionStorage.getItem("userid"))],
            lead: [this.lead],
            cdr: [this.cdr],
            disposition: [this.disposition],
            voicemail: [this.voicemail],
            sms: [this.sms],
            email: [this.email],
            objection: [this.objection],
            didcredit: [this.didcredit]
        });
    }

    public saveForm(fg: FormGroup): boolean {
        if (fg.valid) {
            this.vmusername = fg.get("vmusername").value;
            this.vmpassword = fg.get("vmpassword").value;
            this.iduser = parseInt(sessionStorage.getItem("userid"));
            this.lead = fg.get("lead").value;
            this.cdr = fg.get("cdr").value;
            this.disposition = fg.get("disposition").value;
            this.voicemail = fg.get("voicemail").value;
            this.sms = fg.get("sms").value;
            this.email = fg.get("email").value;
            this.objection = fg.get("objection").value;
            this.didcredit = fg.get("didcredit").value;
            return true;
        }
        else {
            return false;
        }
    }
}

/* Zomm Meeting Models Start */

export interface ZoomMeeting {
    id: number,
    key: string,
    secret: string,
    iduser: number,
    email: string,
    zoomurl: string
}

export interface HTTPZoomMeeting {
    key: string,
    secret: string,
    iduser: number,
    email: string,
    zoomurl: string
}

export class ZoomMeetingForm implements HTTPZoomMeeting {
    public key: string;
    public secret: string;
    public iduser: number;
    public email: string;
    public zoomurl: string;
    constructor(data: ZoomMeeting) {
        if (data == null) {
            this.key = "";
            this.secret = "";
            this.iduser = parseInt(sessionStorage.getItem("userid"));
            this.email = "";
            this.zoomurl = "";
        }
        else {
            this.key = data.key;
            this.secret = data.secret;
            this.iduser = parseInt(sessionStorage.getItem("userid"));
            this.email = data.email;
            this.zoomurl = data.zoomurl;
        }
    }
    public makeform(fb: FormBuilder): FormGroup {
        return fb.group({
            key: [this.key],
            secret: [this.secret],
            iduser: [this.iduser],
            email: [this.email],
            zoomurl: [this.zoomurl]
        });
    }

    public saveForm(fg: FormGroup): boolean {
        if (fg.valid) {
            this.key = fg.get("key").value;
            this.secret = fg.get("secret").value;
            this.iduser = parseInt(sessionStorage.getItem("userid"));
            this.email = fg.get("email").value;
            this.zoomurl = fg.get("zoomurl").value;
            return true;
        }
        else {
            return false;
        }
    }
}

/* Zoom Meeting Model Stop */

/* Stripe Payout Account Model Start */
export interface StripePyout {
    id: number,
    email: string,
    business_type: string,
    account_holder_name: string,
    dob: string,
    routing_number: string,
    account_number: string,
    phone: string,
    id_number_provided: string,
    company: string,
    ssn: string
}

export interface HTTPStripePyout {
    email: string,
    business_type: string,
    account_holder_name: string,
    dob: string,
    routing_number: string,
    account_number: string,
    phone: string,
    id_number_provided: string,
    company: string,
    ssn: string
}

export class StripePyoutForm implements HTTPStripePyout {
    public email: string;
    public business_type: string;
    public account_holder_name: string;
    public dob: string;
    public routing_number: string;
    public account_number: string;
    public phone: string;
    public id_number_provided: string;
    public company: string;
    public ssn: string;
    constructor(data: StripePyout) {
        if (data == null) {
            this.email = "";
            this.business_type = "individual";
            this.account_holder_name = "";
            this.dob = "";
            this.routing_number = "";
            this.account_number = "";
            this.phone = "";
            this.id_number_provided = "";
            this.company = "";
            this.ssn = "";
        }
        else {
            this.email = data.email;
            this.business_type = data.business_type;
            this.account_holder_name = data.account_holder_name;
            this.dob = data.dob;
            this.routing_number = data.routing_number;
            this.account_number = data.account_number;
            this.phone = data.phone;
            this.id_number_provided = data.id_number_provided;
            this.company = data.company;
            this.ssn = data.ssn;
        }
    }
    public makeform(fb: FormBuilder): FormGroup {
        return fb.group({
            email: [this.email, Validators.required],
            business_type: [this.business_type, Validators.required],
            account_holder_name: [this.account_holder_name, Validators.required],
            dob: [this.dob, Validators.required],
            routing_number: [this.routing_number, Validators.required],
            account_number: [this.account_number, Validators.required],
            phone: [this.phone, Validators.required],
            id_number_provided: [this.id_number_provided, Validators.required],
            company: [this.company],
            ssn: [this.ssn, Validators.required]
        });
    }

    public saveForm(fg: FormGroup): boolean {
        if (fg.valid) {
            this.email = fg.get("email").value;
            this.business_type = fg.get("business_type").value;
            this.account_holder_name = fg.get("account_holder_name").value;
            this.dob = fg.get("dob").value;
            this.routing_number = fg.get("routing_number").value;
            this.account_number = fg.get("account_number").value;
            this.phone = fg.get("phone").value;
            this.id_number_provided = fg.get("id_number_provided").value;
            this.company = fg.get("company").value;
            this.ssn = fg.get("ssn").value;
            return true;
        }
        else {
            return false;
        }
    }
}


/* Reset Password Model Start */
export interface Panelconfig {
    title: string;
    logo: string;
    theme: string;
    domain: string;
    ssl_certificate: string;
    ssl_key: string;
    navigate: string;
}

export interface HTTPPanelconfig {
    title: string;
    logo: string;
    theme: string;
    domain: string;
    ssl_certificate: string;
    ssl_key: string;
    navigate: string;
}

export class PanelconfigForm implements HTTPPanelconfig {
    public title: string;
    public logo: string;
    public theme: string;
    public domain: string;
    public ssl_certificate: string;
    public ssl_key: string;
    public navigate: string;
    constructor(data: Panelconfig) {
        if (data == null) {
            this.title = "";
            this.logo = "";
            this.theme = "";
            this.domain = "";
            this.ssl_certificate = "";
            this.ssl_key = "";
            this.navigate = "";
        } else {
            this.title = data.title;
            this.logo = data.logo;
            this.theme = data.theme;
            this.domain = data.domain;
            this.ssl_certificate = data.ssl_certificate;
            this.ssl_key = data.ssl_key;
            this.navigate = data.navigate;
        }
    }
    public makeform(fb: FormBuilder): FormGroup {
        return fb.group({
            title: [this.title],
            logo: [this.logo],
            theme: [this.theme],
            domain: [this.domain],
            ssl_certificate: [this.ssl_certificate],
            ssl_key: [this.ssl_key],
            navigate: [this.navigate]
        });
    }

    public saveForm(fg: FormGroup): boolean {
        if (fg.valid) {
            this.title = fg.get("title").value;
            this.logo = fg.get("logo").value;
            this.theme = fg.get("theme").value;
            this.domain = fg.get("domain").value;
            this.ssl_certificate = fg.get("ssl_certificate").value;
            this.ssl_key = fg.get("ssl_key").value;
            this.navigate = fg.get("navigate").value;
            return true;
        }
        else {
            return false;
        }
    }
}
/* Stripe Payout Account Model Stop */